export default __webpack_public_path__ + "static/media/access-fee_it.1ef7b495.png";